import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box, CircularProgress, makeStyles, Typography,
} from '@material-ui/core';

import { GetCourseByUser, GetTopicById, UpdateAnswerQuizzByUser } from '../../services/courses';
import ReturnButton from '../General/ReturnButton';

import FinalQuizz from './FinalQuizz/Index';
import Question from './Question';
import RadioButtonsContainer from './RadioButtonsContainer';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2, 6),
  },
  containerPage: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerQuizz: {
    maxWidth: 700,
    margin: theme.spacing(3, 0),
  },
  containerResults: {
    padding: theme.spacing(5, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  containerQuizzCompleted: {
    height: '70vh',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textQuizzCompleted: {
    color: theme.palette.text.default,
    fontSize: 30,
    fontFamily: 'Raleway',
  },
}));
function Evaluation() {
  const classes = useStyles();
  const location = useLocation();
  const [quizquestion, setQuizquestion] = useState(null);
  const [index, setIndex] = useState(0);
  const [answerValue, setAnswer] = useState({
    answer: '',
    question: '',
  });
  const [isLoading, setLoading] = useState(true);
  const [startQuizz, setStartQuizz] = useState(false);
  const [score, setScore] = useState(0);
  const [answers] = useState([]);
  const [showScoreAndAnswers, setShowScoreAndAnswers] = useState(false);
  const [isComplitedQuizz, setIsComplitedQuizz] = useState(0);
  const [updateScoreQuizz, setUpdateScoreQuizz] = useState(false);
  const [completedTopic, setCompletedTopic] = useState(false);

  const getQuizz = async () => {
    const courseByUser = await GetCourseByUser(location.state.idUser, location.state.course);
    const fileSelected = courseByUser.data[0].topicsByUser.find(
      (e) => e.idTopic === location.state.topic,
    ).quizByUser[0].score;
    setIsComplitedQuizz(fileSelected);
    const topicById = await GetTopicById(location.state.topic);
    const quizz = topicById.data.quiz[0].quiz;
    setQuizquestion(quizz);
    setLoading(false);
  };

  const amountScore = () => setScore(score + 1);

  const minusScore = () => setScore(score - 1);

  const storeAnswers = (answer) => {
    answers.push(answer);
    setAnswer({
      answer: '',
      question: '',
    });
  };

  const changeAnswerValue = (e) => {
    setAnswer({
      answer: e.target.value,
      question: e.target.name,
    });
  };

  const deleteAnswer = () => answers.pop();

  const changeIndex = () => setIndex(index + 1);
  const backIndex = () => setIndex(index - 1);

  const handleBackButton = () => {
    minusScore();
    deleteAnswer();
    backIndex();
  };

  const startEvaluation = () => setStartQuizz(true);

  const printDefaultView = () => (
    <Box>
      { isComplitedQuizz === undefined ? (
        <Box>
          <Question dataQuestions={quizquestion.length} question="Esta prueba  es necesaria para medir cuanto has aprendido. Después de realizarla podrás continuar aprendiendo" instructions start={startEvaluation} />
        </Box>
      ) : (
        <Box className={classes.containerQuizzCompleted}>
          <Typography className={classes.textQuizzCompleted}>Evaluación realizada</Typography>
        </Box>
      )}
    </Box>
  );

  const submitAnswers = async () => {
    setUpdateScoreQuizz(true);
    storeAnswers({
      id: quizquestion[index].id,
      answer: answerValue.answer,
    });
    const dataAswers = {
      idQuizUser: location.state.quizzId,
      answers,
      score,
      idUser: location.state.idUser,
      idCourse: location.state.course,
      idTopic: location.state.topic,
      idTopicUser: location.state.idTopicUser,
      idFinalProjectUser: location.state.finalProjectUserId,
    };
    const response = await UpdateAnswerQuizzByUser(dataAswers);
    try {
      if (response.data.completedTopic) {
        setCompletedTopic(true);
        setShowScoreAndAnswers(true);
        setUpdateScoreQuizz(false);
      } else {
        setShowScoreAndAnswers(true);
        setUpdateScoreQuizz(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getQuizz();
  }, []);
  return (
    <Box className={classes.container}>
      {!showScoreAndAnswers ? (
        <>
          <ReturnButton />
          <Box container className={classes.containerPage}>
            {isLoading ? <CircularProgress color="inherit" />
              : !startQuizz ? printDefaultView() : (
                <Box className={classes.containerQuizz}>
                  <Question
                    question={quizquestion[index].question}
                  />
                  <RadioButtonsContainer
                    value={answerValue.answer}
                    actions={changeIndex}
                    totalQuestions={quizquestion.length}
                    options={quizquestion[index].alternatives}
                    changeValue={changeAnswerValue}
                    correctAnswer={quizquestion[index].answer}
                    indexQuestion={index}
                    idQuestion={quizquestion[index].id}
                    amountScore={amountScore}
                    storeAnswers={storeAnswers}
                    finalAction={submitAnswers}
                    isLoading={updateScoreQuizz}
                    backAction={handleBackButton}
                  />
                </Box>
              )}
          </Box>

        </>
      ) : (
        <Box className={classes.containerResults}>
          <FinalQuizz
            correct={score}
            total={quizquestion.length}
            incorrect={quizquestion.length - score}
            userAnswers={answers}
            correctAnswers={quizquestion}
            listQuestions={quizquestion.length}
            completedTopic={completedTopic}
          />
        </Box>
      )}
    </Box>
  );
}

export default Evaluation;
